module.exports = __webpack_public_path__ + "media/images/anxious_face-272c6ca7e551cde1cfd62ea16b742f2f.svg";